module.exports = __webpack_public_path__ + "img/Comercial.5588e079.png";